import ScheduleFields from './ScheduleFields';

export default ScheduleFields;
